import { FC, PropsWithChildren } from "react";
import { TableProps, Table } from "@/components/Table";
import {
  ExternalSourceType,
  TableExternalDataRows,
} from "@/components/Table/TableExternalDataRows";

export const TableBlock: FC<
  PropsWithChildren<TableProps & { externalSource?: ExternalSourceType }>
> = ({ children, externalSource, ...props }) => (
  <Table {...props}>
    {children}
    <TableExternalDataRows externalSource={externalSource} />
  </Table>
);
